import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import StyledButton from 'components/shared/StyledButton/StyledButton';
import { PalletBalance } from 'interfaces';
import { getPalletsAmountLabel } from 'utils/functions';

import styles from './DamageLossPalletsSummary.module.css';

type DamageLossPalletsSummaryProps = {
   title?: string;
   damageLossPalletsSummaryData: PalletBalance;
   onClickDetails: () => void;
   className?: string;
};

const DamageLossPalletsSummary = ({
   title,
   damageLossPalletsSummaryData,
   onClickDetails,
   className,
}: DamageLossPalletsSummaryProps) => {
   const { t } = useTranslation();

   return (
      <div className={classNames(styles.container, className)}>
         {title && <h4>{title}</h4>}
         <>
            <span className={styles.summaryItem}>
               <span className={styles.summaryItemTitle}>{t('damageLossPalletsSummary.edhp')}</span>
               <span className={styles.summaryItemAmount}>
                  {getPalletsAmountLabel('EDHP_PALLET', damageLossPalletsSummaryData)}
               </span>
            </span>
            <span className={styles.summaryItem}>
               <span className={styles.summaryItemTitle}>{t('damageLossPalletsSummary.euro')}</span>
               <span className={styles.summaryItemAmount}>
                  {getPalletsAmountLabel('EURO_PALLET', damageLossPalletsSummaryData)}
               </span>
            </span>
            <span className={styles.summaryItem}>
               <span className={styles.summaryItemTitle}>{t('damageLossPalletsSummary.half')}</span>
               <span className={styles.summaryItemAmount}>
                  {getPalletsAmountLabel('HALF_PALLET_NDHP', damageLossPalletsSummaryData)}
               </span>
            </span>
            <span className={styles.summaryItem}>
               <span className={styles.summaryItemTitle}>
                  {t('damageLossPalletsSummary.quarter')}
               </span>
               <span className={styles.summaryItemAmount}>
                  {getPalletsAmountLabel('QUARTER_PALLET_CDHP', damageLossPalletsSummaryData)}
               </span>
            </span>
            <StyledButton
               variant="filled-primary"
               type="button"
               onClick={onClickDetails}
               text={t('common.details')}
            />
         </>
      </div>
   );
};

export default DamageLossPalletsSummary;
